import { Component, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { INewsDetails } from '@models';
import { ModalController } from '@ionic/angular';
import { NewsDetailsComponent } from '@shared/modals/news-details/news-details.component';
import { FileTypesEnum } from '@enums';

@Component({
    selector: 'anp-news-item',
    templateUrl: './news-item.component.html',
    styleUrls: ['./news-item.component.scss'],
    standalone: false
})
export class NewsItemComponent implements AfterViewInit {
  @Input() public news: INewsDetails;
  @Output() public categorySelected = new EventEmitter<number>();
  public fileTypes = FileTypesEnum;
  constructor(private modalCtrl: ModalController) {}

  public ngAfterViewInit(): void {
    setTimeout(this.removeButtonBehaviour, 1000);

    document.getElementById('description-' + this.news.Id).innerHTML = this.news.Description;

  }

  //creating the modal for news details
  public async onOpenNews(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: NewsDetailsComponent,
      componentProps: {
        news: this.news
      }
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
    if (data) this.categorySelected.emit(data);
  }

  /** Quitar efecto de boton de los ion-chip para evitar confusiones */
  private removeButtonBehaviour(): void {
    const chips = document.querySelectorAll('ion-chip');
    chips.forEach((chip) => {
      chip.classList.remove('ion-activatable');
    });
  }
}
